import React, { useEffect, useState } from 'react';
import { AiFillCustomerService, AiOutlineBell, AiOutlineUser } from 'react-icons/ai';
import { FaBars, FaChartBar, FaCogs, FaHandshake, FaUser, FaBell, FaList, FaCog, FaUsers, FaUpload, FaMoneyBill, FaSignOutAlt, FaBuilding, FaShoppingCart, FaCashRegister, FaUserSlash } from 'react-icons/fa';
import { FaListCheck, FaUsersGear } from 'react-icons/fa6';
import { MdDashboard, MdEvent } from 'react-icons/md';
import { Outlet, useLocation, NavLink  } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../helpers';
import { FcCustomerSupport, FcPlanner } from 'react-icons/fc';
import { BiReceipt } from 'react-icons/bi';
import { PiInvoice } from 'react-icons/pi';
import { CiSettings } from 'react-icons/ci';
import { IoIosSwap } from 'react-icons/io';


export default function UserLayout() {

    const auth = useAuth();

    const [allData, setAllData] = useState([]) 
    const [transactions, setTransactions] = useState([]);

    const check = async () =>{
      try{
        const response = await axios.get(rootUrl(`/checkUser/${auth.user?.id}`))
        if(response.data.status != 200){
            //  window.location.href = "/"
        }
      }catch(e){
        // window.location.href = "/"
      }
    }

    const getGen = async () =>{
      try{
        const response = await axios.get(rootUrl(`/getGeneral/${auth.user?.id}`))
        if(response.data.status == 200){
             setAllData(response.data.data)
            //  console.log(response.data.data)
        }
      }catch(e){
        toast.error(e?.message)
      }
    }

    const fetchTransactions = async () => {
      try {
        const response = await axios.get(rootUrl(`/getTrans/${auth.user?.id}`));
        console.log(response.data.cash)
        setTransactions(response.data.cash);
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
      }
    };
  



    useEffect(()=>{
      check()
      getGen()
      fetchTransactions()
    }, [])

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();
    const currentUrl = location.pathname + location.search;
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    const routes = [
      { path: '/', name: 'Dashboard', icon: <MdDashboard className="mr-2" /> },
      { path: '/bills', name: 'Bills', icon: <PiInvoice className="mr-2" /> },
      // { path: '/receipts', name: 'Receipts', icon: <BiReceipt className="mr-2" /> },
      { path: '/cashbook', name: 'Cash Book', icon: <FaCashRegister className="mr-2" /> },
      { path: '/suppliers', name: 'Suppliers', icon: <FaShoppingCart className="mr-2" /> },
      { path: '/customers', name: 'Customers', icon: <FaUsersGear className="mr-2" /> },
      // { path: '/properties', name: 'Properties', icon: <FaBuilding className="mr-2" />  },
      { path: '/journal', name: 'Journal', icon: <IoIosSwap className="mr-2" />  },
      { path: '/budget', name: 'Budget', icon: <MdEvent className="mr-2" />  },
      { path: '/reports', name: 'Reports', icon: <FaChartBar className="mr-2" />  },
      
    ];

    const signOut = () => {

      auth.logOut(()=>{
        window.location.reload()
      })
  
    }

return (
    <div className="flex bg-gray-200">
      {/* Sidebar */}
      <div className={`fixed bottom-0 top-0 w-1/5 text-lg bg-white text-black py-4 shadow-2xl transform  lg:translate-x-0 transition-transform duration-300 ease-in-out`}>
        <div className="mb-4 text-center font-bold">
          <img src="/logo1.png" alt="Logo" className="mx-auto w-1/3" />
        </div>

        <hr className='mb-5' />
        <ul className="space-y-2">
          {routes.map((route) => (
            <li
              key={route.path}
              className={`rounded-l-3xl cursor-pointer py-2 ml-4 pl-3 flex items-center text-lg ${currentUrl === route.path ? 'bg-gray-300 text-black' : ''}`}
            >
              <NavLink to={route.path} className="flex items-center w-full">
                {route.icon} {route.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Main Content */}
      <div className={`p-6 ml-auto w-full lg:w-4/5`} id="main-content">
        <div className="bg-white rounded-lg shadow p-4 mb-4">
          <header className="flex justify-between items-center">
            <h1 className="text-xl font-semibold flex items-center">
              {/* <button className="mr-2 text-gray-800 cursor-pointer lg:hidden" onClick={toggleSidebar}>
                <FaBars/>
              </button> */}
              <span>Admin</span>
            </h1>
           
            <div className="flex items-center space-x-4">
              <a href="#" className="relative text-gray-800 flex items-center">
              <NavLink to={'/transactions'} className="relative inline-block m-2">
              <AiOutlineBell size={30} className="" />
              {transactions?.length > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {transactions?.length}
                </span>
              )}
            </NavLink>
                <AiOutlineUser size={30} className='m-2'/>
                
                <FaSignOutAlt onClick={signOut} title='logout' className='text-2xl'/>
              </a>
              <a className="text-gray-800 flex items-center">
                <i className="fa fa-user fa-2x mr-1"></i>
              </a>
            </div>
          </header>
        </div>

      <div className='bg-gray-100 p-5 bg-white rounded-lg shadow-lg overflow-x-auto'>
      <Outlet context={allData} />
      </div>
              

        <div className="bg-white rounded-lg shadow p-2 mt-4">
          <footer className="text-center">
            &copy; {new Date().getFullYear()}. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );

}